import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface AdminUser {
  id: number;
  name: string;
  email: string;
  /** admin = grupo admin do Entra; sales = grupo comercial. */
  role: 'admin' | 'sales';
  provider: 'microsoft' | 'local';
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);
  readonly user = signal<AdminUser | null>(null);
  readonly isAdmin = computed(() => this.user()?.role === 'admin');

  /** Formas de entrar ligadas no servidor (Microsoft 365 e/ou emergência). */
  options(): Promise<{ microsoft: boolean; local: boolean }> {
    return firstValueFrom(this.http.get<{ microsoft: boolean; local: boolean }>('/api/admin/auth/options'));
  }

  /** Sessão já existente? (chamado pelo guard antes de qualquer tela). */
  async restore(): Promise<boolean> {
    if (this.user()) return true;
    try {
      this.user.set(await firstValueFrom(this.http.get<AdminUser>('/api/admin/me')));
      return true;
    } catch {
      return false;
    }
  }

  async login(email: string, password: string): Promise<void> {
    // Recebe o cookie XSRF-TOKEN; o HttpClient o devolve no header X-XSRF-TOKEN.
    await firstValueFrom(this.http.get('/api/admin/csrf'));
    this.user.set(await firstValueFrom(this.http.post<AdminUser>('/api/admin/login', { email, password })));
  }

  async logout(): Promise<void> {
    try {
      await firstValueFrom(this.http.post('/api/admin/logout', {}));
    } finally {
      this.user.set(null);
    }
  }
}
